import { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import * as dealApis from "../utilities/apis/deal"
import * as productApis from "../utilities/apis/product"
import { getSrc } from "../utilities/enumerations/constants"

const AttachmentModal = (props) => {
  const { token } = useSelector(state => state.user)
  const modalRef = useRef(null)
  const [tab, setTab] = useState("deal")
  const [deals, setDeals] = useState([])
  const [products, setProducts] = useState([])

  const getItems = async () => {
    try {
      const [dealResponse, productResponse] = await Promise.all([
        dealApis.getDeals(token, ""),
        productApis.getProducts(token, ""),
      ])
      if (!dealResponse.status) throw new Error(dealResponse.message)
      if (!productResponse.status) throw new Error(productResponse.message)

      setDeals(dealResponse.deals)
      setProducts(productResponse.products)
    } catch (error) {
      setDeals([])
      setProducts([])
    }
  }

  useEffect(() => {
    // Refresh the lists every time the modal opens
    const modal = modalRef.current
    modal.addEventListener("show.bs.modal", getItems)

    return () => modal.removeEventListener("show.bs.modal", getItems)
  }, [token])

  const items = tab === "deal"
    ? deals.map((deal) => ({
      type: "deal",
      id: deal.id,
      title: deal.title,
      thumbnail_url: deal.thumbnail_url || "",
      items: deal.deal_products.length,
      price: deal.price - deal.discount,
    }))
    : products.map((product) => ({
      type: "product",
      id: product.id,
      title: product.title,
      thumbnail_url: product.thumbnail_url || "",
      price: product.price,
    }))

  return (
    <div ref={modalRef} className="modal fade" id="attachmentModal" tabIndex="-1" aria-labelledby="attachmentModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-md modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5 fw-bold" id="attachmentModalLabel">Product / Deal Attachment</h1>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body p-0">
            <ul className="nav nav-pills gap-2 p-2">
              <li className="nav-item"><button type="button" className={`nav-link ${tab === "deal" ? "active" : ""}`} onClick={() => setTab("deal")}>Deals</button></li>
              <li className="nav-item"><button type="button" className={`nav-link ${tab === "product" ? "active" : ""}`} onClick={() => setTab("product")}>Products</button></li>
            </ul>
            <div className="list-group list-group-flush">
              {items.length === 0 && <p className="text-center text-muted small m-0 p-3">No {tab === "deal" ? "deals" : "products"}</p>}
              {items.map((item) => {
                return (
                  <button key={`${item.type}-${item.id}`} type="button" className="list-group-item list-group-item-action d-flex gap-2 align-items-center" onClick={() => props.handleSelect(item)} data-bs-dismiss="modal">
                    <img src={getSrc(item.thumbnail_url)} className="border rounded-3" alt={item.title} width={48} height={48} />
                    <div>
                      <div className="fw-bold">{item.title}</div>
                      <div className="small text-muted">{item.type === "deal" && `${item.items} items · `}Rs. {item.price.toFixed(2)}</div>
                    </div>
                  </button>
                )
              })}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AttachmentModal
